<template>
  <el-form ref="formRef" :model="formData" :rules="rules" @submit.native.prevent>
    <el-form-item :label="dateLabel" prop="range_time">
        <el-date-picker
            v-model="formData.range_time"
            :disabled="loading"
            type="daterange"
            :clearable="false"
            value-format="yyyy-MM-dd"
            style="width: 310px;"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
        />
    </el-form-item>
  </el-form>
</template>

<script>
import dayjs from 'dayjs';
export default {
    props: [ 'dateLabel', 'defaultData', 'cbs', 'loading' ],
    name: 'DateType',
    data() {
        const { range_time } = this.defaultData || {};
        const _this = this;
        return {
            formData: {
                range_time: range_time || []
            },
            rules: {
                range_time: [
                    { required: true, message: '请选择日期', trigger: 'blur' },
                ]
            },
            dateData: {},
            pickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    // 所选筛选条件在该日期无任何数据
                    return _this.isDisabledDate(time)
                },
            }
        }
    },
    computed: {
        disabledDateData() {
            return (this.dateData.has_cost_date || []).reduce((pre, item)=> {
                pre[this.formatDate(item)] = true;
                return pre;
            }, {})
        }
    },
    mounted() {
        this.$emit('disable-date', (dateData)=> {
            this.dateData = dateData
        })
    },
    methods: {
        isDisabledDate(time) {
             time = this.formatDate(time);
            // const { end_date, all_disabled, start_date, has_cost_date } = this.dateData;
            // 大于今日
            if (new Date(time).getTime() > new Date().getTime()) {
                return true;
            };
            // 小于起始日期
            const startDate = this.dateData.start_date;
            if (startDate && new Date(time).getTime() < new Date(this.formatDate(startDate) ).getTime()) {
                return true
            };
            if (!this.disabledDateData[time]) {
                return true;
            }
            return false
        },
        // 格式化日期
        formatDate(date) {
            return dayjs(date).format('YYYY-MM-DD')
        },
        async getFormData() {
            const valid = await this.$refs['formRef'].validate();
            if (valid) {
                return {
                    ...this.formData
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>